import React, { useState, useEffect } from "react";
import { WagmiProvider } from "wagmi";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { chains, wagmiConfig } from "./web3Config";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ChainList from "./pages/ChainList";
import Statistics from "./pages/Statistics";
import Promotions from "./pages/Promotions";
import Settings from "./pages/Settings";
import InviteCode from "./pages/InviteCode";
import AcceptInvite from "./pages/AcceptInvite";
import DashboardLayout from "./components/DashboardLayout";
import TopNavbar from "./components/TopNavbar";
import { useAccount } from "wagmi";
import ContractTest from "./pages/ContractTest";

const queryClient = new QueryClient();

const RequireWalletConnection: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isConnected } = useAccount();

  useEffect(() => {
    if (!isConnected) {
      window.location.replace("/"); // Redirect to LoginPage if not connected
    }
  }, [isConnected]);

  return <>{children}</>;
};

const AppContent: React.FC = () => {
  const { address } = useAccount();
  const [walletAddress, setWalletAddress] = useState<string | null>(null);

  useEffect(() => {
    if (address) {
      setWalletAddress(address);
    }
  }, [address]);

  console.log("Current Wallet Address:", walletAddress);

  return (
    <Router>
      <Routes>
        {/* Login Page */}
        <Route path="/" element={<LoginPage />} />
  
        {/* Protected Dashboard Routes */}
        <Route
          path="/dashboard/*"
          element={
            <RequireWalletConnection>
              <Routes>
                {/* Routes with DashboardLayout */}
                <Route
                  path="*"
                  element={
                    <DashboardLayout>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="projects" element={<Projects />} />
                        <Route path="chainlist" element={<ChainList />} />
                        <Route path="statistics" element={<Statistics />} />
                        <Route path="promotions" element={<Promotions />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="test" element={<ContractTest />} />
                        <Route path="*" element={<Navigate to="/dashboard" />} />
                      </Routes>
                    </DashboardLayout>
                  }
                />
  
                {/* Route without Sidebar */}
                <Route
                  path="accept-invite"
                  element={
                    <>
                      <TopNavbar />
                      <div style={{ paddingTop: '3rem' }}>
                      <AcceptInvite />
                      </div>   
                    </>
                  }
                />
                <Route
                  path="invite-code"
                  element={
                    <>
                      <TopNavbar />
                      <div style={{ paddingTop: '3rem' }}>
                      <InviteCode />
                      </div>   
                    </>
                  }
                />
              </Routes>
            </RequireWalletConnection>
          }
        />
      </Routes>
    </Router>
  ); 
};

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={wagmiConfig}>
        <RainbowKitProvider>
          <AppContent />
        </RainbowKitProvider>
      </WagmiProvider>
    </QueryClientProvider>
  );
};

export default App;